<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-light`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.444 32.333a8.556 8.556 0 0017.111 0h-17.11zm26.523-3.666C40.267 20.298 32.87 14 24 14S7.732 20.298 6.033 28.667h35.934zM25 3a1 1 0 011 1v6.424l.19.017C37.311 11.54 46 20.921 46 32.333h-9.778c0 6.75-5.472 12.222-12.222 12.222-6.75 0-12.222-5.471-12.222-12.222H2c0-11.476 8.786-20.9 20-21.91V4a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconLight',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
